var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.682,
    height: 16.971,
    viewBox: "0 0 7.682 16.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expand_icon",
    "data-name": "Expand icon",
    transform: "translate(-7.685 8.485) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    transform: "translate(2.15 2.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M18.359,6.985a.626.626,0,0,1-.626-.626V3.4H14.776a.626.626,0,0,1,0-1.252h3.583a.626.626,0,0,1,.626.626V6.359A.626.626,0,0,1,18.359,6.985Z",
    transform: "translate(-6.985 -2.15)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M6.359,18.985H2.776a.626.626,0,0,1-.626-.626V14.776a.626.626,0,0,1,1.252,0v2.957H6.359a.626.626,0,0,1,0,1.252Z",
    transform: "translate(-2.15 -6.985)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M13.776,7.582a.626.626,0,0,1-.443-1.069l4.18-4.18a.626.626,0,0,1,.885.885L14.219,7.4A.624.624,0,0,1,13.776,7.582Z",
    transform: "translate(-6.582 -2.15)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M2.776,18.582a.626.626,0,0,1-.443-1.069l4.18-4.18a.626.626,0,0,1,.885.885L3.219,18.4A.624.624,0,0,1,2.776,18.582Z",
    transform: "translate(-2.15 -6.582)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandSmall);
export default __webpack_public_path__ + "static/media/ExpandSmall.ea3aca62c2c3d3a0de6bc4f47b19bc7c.svg";
export { ForwardRef as ReactComponent };